import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  loading = false;
  error = '';
  success = false;
  token = '';
  tokenValid = false;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.resetForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    this.tokenValid = this.token.length >= 20;

    if (!this.tokenValid) {
      this.error = 'El enlace de restablecimiento es invalido o ha expirado.';
    }
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password');
    const confirmPassword = form.get('confirmPassword');

    if (password && confirmPassword && password.value !== confirmPassword.value) {
      confirmPassword.setErrors({ passwordMismatch: true });
    } else if (confirmPassword?.errors?.['passwordMismatch']) {
      delete confirmPassword.errors['passwordMismatch'];
      if (Object.keys(confirmPassword.errors).length === 0) {
        confirmPassword.setErrors(null);
      }
    }
    return null;
  }

  async onSubmit(): Promise<void> {
    if (this.resetForm.invalid || !this.tokenValid) return;

    this.loading = true;
    this.error = '';

    const { password } = this.resetForm.value;

    try {
      const response = await this.http.post<{ success: boolean; message?: string }>(
        '/api/v1/auth/reset-password',
        { token: this.token, new_password: password }
      ).toPromise();

      if (response?.success) {
        this.success = true;
      } else {
        this.error = response?.message || 'Error al restablecer la contrasena';
      }
    } catch (error: any) {
      this.error = error?.error?.message || 'Error al restablecer la contrasena';
    } finally {
      this.loading = false;
    }
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }

  get f() {
    return this.resetForm.controls;
  }
}
